import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { Aside, EditButton } from "sprint-common-web";

import { MuxSpecificationsDataContext } from "../../../../../common/data/lookup-data-providers/MuxSpecificationsDataProvider";
import { EditEncodeConfigurationForm } from "./EditEncodeConfigurationForm";

export const EditEncodeConfigurationButton: React.VFC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const { systemId } = useParams<{ systemId: string }>();

    const { isLoading: isMuxSpecificationSpecificationsLoading } = useContext(MuxSpecificationsDataContext);

    const isLoading = isMuxSpecificationSpecificationsLoading;

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    return (
        <>
            <EditButton onClick={openSidebar} isLabeled label="Edit" testId="edit-encode-configuration" />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar} isLoading={isLoading}>
                <EditEncodeConfigurationForm onCancel={closeSidebar} onSubmit={closeSidebar} systemId={systemId} />
            </Aside>
        </>
    );
};
